var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col flex-grow items-center justify-center py-8" },
    [
      !_vm.$auth.isLoggedIn()
        ? [
            _c("BaseIcon", {
              staticClass: "w-48 h-48",
              attrs: { name: "media-kraken" }
            }),
            _c("h1", { staticClass: "mt-4 text-3xl font-semibold" }, [
              _vm._v(" Media Kraken ")
            ]),
            _c(
              "div",
              { staticClass: "flex flex-col items-center mt-1 max-w-md" },
              [
                _c(
                  "p",
                  {
                    staticClass:
                      "text-sm text-gray-800 text-center leading-relaxed mb-6"
                  },
                  [
                    _vm._v(
                      " Keep track of your movies and create your own collection! "
                    )
                  ]
                ),
                _vm.previousLoginUrl
                  ? _c("LoginPrevious", {
                      attrs: { "login-url": _vm.previousLoginUrl },
                      on: {
                        login: _vm.loginWithPreviousLogin,
                        forget: _vm.forgetPreviousLogin
                      }
                    })
                  : _vm.loginUrl !== null
                  ? _c("LoginSolid", {
                      attrs: { "login-url": _vm.loginUrl },
                      on: {
                        updateLoginUrl: function($event) {
                          _vm.loginUrl = $event
                        },
                        submit: _vm.submitLoginWithSolid
                      }
                    })
                  : _c(
                      "div",
                      { staticClass: "flex flex-col items-center" },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "self-start text-gray-800 mb-3 text-sm"
                          },
                          [_vm._v(" Where do you want to store your data? ")]
                        ),
                        _c(
                          "BaseButton",
                          {
                            staticClass:
                              "\n                        w-64 h-10 mb-3 text-sm font-medium tracking-wide shadow\n                        bg-brand-solid-500 text-white hover:bg-brand-solid-700\n                    ",
                            attrs: { icon: "solid-emblem" },
                            on: { click: _vm.loginWithSolid }
                          },
                          [_vm._v(" Use Solid ")]
                        ),
                        _c(
                          "BaseButton",
                          {
                            staticClass:
                              "\n                        w-64 h-10 text-sm font-medium tracking-wide shadow\n                        text-white bg-blue-500 hover:bg-blue-700\n                    ",
                            attrs: {
                              icon: "browser",
                              "icon-class": "w-6 h-4 mr-2"
                            },
                            on: { click: _vm.loginOffline }
                          },
                          [_vm._v(" Use browser storage ")]
                        ),
                        _c(
                          "BaseLink",
                          {
                            staticClass: "self-center mt-4 text-sm",
                            on: {
                              click: function($event) {
                                return _vm.$ui.openFileMarkdownModal(
                                  "application-storage"
                                )
                              }
                            }
                          },
                          [_vm._v(" Help me decide what to use ")]
                        )
                      ],
                      1
                    )
              ],
              1
            )
          ]
        : _c(
            "p",
            { staticClass: "font-medium" },
            [
              _vm._v(" You are logged in! Please "),
              _c(
                "BaseLink",
                { staticClass: "underline", attrs: { route: "home" } },
                [_vm._v(" go home ")]
              ),
              _vm._v(" or "),
              _c(
                "button",
                {
                  staticClass:
                    "font-medium text-primary-700 underline inline-block hover:text-primary-900",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$auth.logout()
                    }
                  }
                },
                [_vm._v(" logout ")]
              ),
              _vm._v(" first. ")
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }